import React from "react";

const MARKETS = [
  { n: 1, name: "Med Spas & Aesthetic Clinics",
    pain: "Missed calls and slow lead follow-up. Leads from ads go cold within minutes. Front desk can't keep up.",
    paying: "$2,500 to $4,000/mo for front-desk staff plus ad spend that leaks.",
    offer: "Speed-to-lead system. AI answers every inquiry in under 60 seconds, qualifies, and books consults directly to the calendar.",
    price: "$3,500 to $6,000 setup plus $500 to $1,000/mo." },
  { n: 2, name: "Roofing & Storm Restoration Contractors",
    pain: "After-hours calls during storm season are pure gold and go straight to voicemail. Estimators drown in unqualified tire-kickers.",
    paying: "Answering services ($300 to $800/mo) that just take messages.",
    offer: "24/7 storm-response intake agent that qualifies damage, captures insurance details, and schedules inspections.",
    price: "$5,000 setup plus $750/mo." },
  { n: 3, name: "Law Firms (PI and Family Law)",
    pain: "Intake is the bottleneck. Paralegals spend hours on unqualified consult requests. A missed intake is a five-figure case lost.",
    paying: "Intake staff at $45,000+/yr, legal answering services.",
    offer: "AI intake system that screens for case fit, collects the fact pattern, and books qualified consults only.",
    price: "$6,000 to $10,000 setup plus $1,000/mo." },
  { n: 4, name: "Real Estate Teams & Brokerages",
    pain: "Agents ignore aged leads. Thousands of dollars of old leads sit dead in the CRM.",
    paying: "ISAs at $3,000 to $4,500/mo, lead gen subscriptions they don't work.",
    offer: "Database reactivation system. AI works the dead CRM leads by text, revives conversations, and hands off live buyers/sellers.",
    price: "$4,000 setup plus performance component per revived appointment." },
  { n: 5, name: "Dental Practices (Implants & Ortho)",
    pain: "High-value treatment plans ($5K to $30K cases) get presented and never followed up. Patients \"think about it\" forever.",
    paying: "Treatment coordinators, patient financing partners, ads for new patients while old quotes rot.",
    offer: "Unscheduled treatment follow-up system that nurtures presented-but-unclosed cases back to the chair.",
    price: "$5,000 setup plus $800/mo." },
  { n: 6, name: "HVAC & Home Services",
    pain: "Seasonal call spikes overwhelm dispatch. Membership renewals lapse silently. After-hours emergencies go to competitors.",
    paying: "CSRs, call centers, marketing agencies.",
    offer: "Overflow and after-hours booking agent plus automated membership-renewal recovery.",
    price: "$4,500 setup plus $600/mo." },
  { n: 7, name: "Fitness Studios & Gyms (Boutique)",
    pain: "Trial members ghost. Cancellation saves never happen. Front desk staff turn over constantly.",
    paying: "$15 to $20/hr front desk, churn they've accepted as normal.",
    offer: "Member lifecycle system: trial follow-up, no-show recovery, and cancellation-save conversations, all automated.",
    price: "$3,000 setup plus $400 to $600/mo." },
  { n: 8, name: "Mortgage Brokers & Loan Officers",
    pain: "Pre-qualified borrowers go quiet during rate shopping. Past clients refinance with someone else because nobody stayed in touch.",
    paying: "LOAs, CRM subscriptions used at 10% capacity.",
    offer: "Borrower nurture system that keeps applications warm and mines the past-client database for repeat and referral business.",
    price: "$4,000 setup plus $500/mo." },
  { n: 9, name: "Auto Dealerships (Independent & Used)",
    pain: "Internet leads answered in hours instead of minutes. BDC staff cost a fortune and burn out.",
    paying: "BDC reps at $3,000+/mo each, lead providers.",
    offer: "Instant-response internet sales agent that engages every lead, answers inventory questions, and books test drives.",
    price: "$5,000 setup plus $1,000/mo." },
  { n: 10, name: "Coaches, Consultants & Course Creators (High-Ticket)",
    pain: "DMs and webinar leads pile up unanswered. Setters cost commissions plus base. Show rates on booked calls are brutal.",
    paying: "Setters (base plus 3 to 5%), show-rate loss they don't measure.",
    offer: "AI setter that works every lead, qualifies against their ideal-client criteria, books to calendar, and runs show-rate sequences.",
    price: "$4,000 to $7,000 setup plus $750/mo." },
];

const Row = ({ label, children }) => (
  <div style={{ display: "grid", gridTemplateColumns: "150px 1fr", gap: 12, padding: "6px 0" }}>
    <span className="font-mono-plex" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", color: "var(--muted)" }}>{label}</span>
    <span style={{ fontSize: 15 }}>{children}</span>
  </div>
);

export default function MarketList() {
  return (
    <div className="prose-weekend" data-testid="asset-body-market-list">
      <p style={{ color: "var(--muted)" }}>10 Funded Niches Already Paying to Solve These Problems</p>
      <p style={{ fontSize: 15 }}>How to use this: Pick ONE on Friday night. Every entry passes the three filters (Funded, Painful, Reachable). Suggested pricing assumes the positioning frameworks in Asset 04 are applied.</p>

      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginTop: 18 }}>
        {MARKETS.map((m) => (
          <div key={m.n} style={{ border: "1px solid var(--line)", borderRadius: 12, padding: 18 }}>
            <div style={{ display: "flex", gap: 10, alignItems: "baseline" }}>
              <span className="font-archivo" style={{ fontWeight: 900, color: "#2038E6", fontSize: 18 }}>{m.n}.</span>
              <h3 style={{ fontFamily: "Archivo, sans-serif", fontWeight: 800, fontSize: 18, margin: 0 }}>{m.name}</h3>
            </div>
            <div style={{ marginTop: 10 }}>
              <Row label="Pain">{m.pain}</Row>
              <Row label="Currently paying">{m.paying}</Row>
              <Row label="The offer">{m.offer}</Row>
              <Row label="Price"><strong>{m.price}</strong></Row>
            </div>
          </div>
        ))}
      </div>

      <h3 style={{ fontFamily: "Archivo, sans-serif", fontWeight: 800, marginTop: 28 }}>The Selection Exercise (Friday Night, 20 Minutes)</h3>
      <p style={{ fontSize: 15 }}>Score each market you're considering, 1 to 5, on:</p>
      <ol style={{ paddingLeft: 20 }}>
        <li style={{ margin: "6px 0" }}><strong>Access:</strong> Do I know anyone in this world, or can I list 50 of them by Sunday?</li>
        <li style={{ margin: "6px 0" }}><strong>Affinity:</strong> Would I enjoy 30 days of conversations with these people?</li>
        <li style={{ margin: "6px 0" }}><strong>Ammo:</strong> Do I have any story, background, or credibility touching this industry?</li>
      </ol>
      <p style={{ fontSize: 15 }}>Highest total wins. Ties go to the market with the highest ticket. Write your commitment sentence and stop deliberating:</p>
      <blockquote style={{ borderLeft: "4px solid #FFDF57", margin: "12px 0", padding: "8px 16px", background: "#FFFBEA", fontStyle: "italic" }}>
        "For the next 30 days I help ______________ fix ______________ with ______________."
      </blockquote>
    </div>
  );
}
